export const isActiveFeature = (featureToCheck, licenses = []) => {
  return licenses.some((license) => license.features.some((feature) => feature === featureToCheck));
};
